import { Avatar as ChackraAvatar } from '@chakra-ui/react'
import { PROTECTED } from 'lib/routes'
import React from 'react'
import { Link } from 'react-router-dom'

const Avatar = ({ user, overrideAvatar = null }) => {
    const handleClick = (e) => {
        e.stopPropagation()
    }
    if (!user) return "Loading..."
    return (
        <ChackraAvatar
            onClick={handleClick}
            as={Link}
            to={`${PROTECTED}/profile/${user.id}`}
            name={user.username}
            src={overrideAvatar || user.avatar}
            _hover={{ cursor: "pointer", opacity: "0.8" }}
        />
    )
}

export default Avatar